import React from "react";
import "./SlotGamesListPageStyle.scss";
import MainLayout from "../../components/MainLayout";
import BannerSection from "../../components/BannerSection";
import ContactUsSection from "../../components/ContactUsSection";
import AllSlotGamesSection from "../../components/AllSlotGamesSection";

const SlotGamesListPage = () => {
  return (
    <MainLayout>
      <div className="slot-games-list-page">
        <BannerSection />
        <AllSlotGamesSection />
        {/* <ContactUsSection /> */}
      </div>
    </MainLayout>
  );
};

export default SlotGamesListPage;
